import { RentalObjectDetails } from '@modules/husleie-framework/src/types/RentalObjectDetails.entity';
import { Category } from '@modules/husleie-framework/src/enums/Category.enum';
import { AdderType } from '@modules/husleie-framework/src/types/Adder';
import FileUpload from '@modules/husleie-framework/src/types/FileUpload.entity';
import Keychain from '@modules/husleie-framework/src/types/Keychain.entity';
import RentalObjectAddress from '@modules/husleie-framework/src/types/RentalObjectAddress.entity';
import { Utility } from '@modules/husleie-framework/src/types/Utility';

const enum RentalObjectFurnishingStandardEnum {
  UNFURNISHED = 'UNFURNISHED',
  FURNISHED = 'FURNISHED',
}

type RentalObjectFurnishingStandard =
  | RentalObjectFurnishingStandardEnum.UNFURNISHED
  | RentalObjectFurnishingStandardEnum.FURNISHED;

interface RentalObject {
  id?: number;
  belongsToBuildingId?: number;
  category: Category;
  address?: RentalObjectAddress;

  electricityMeterNumber?: null | string;
  dateOfConstruction?: null | string;
  squareMeters?: null | number;
  comment?: string;

  rooms?: AdderType[];
  furniture?: AdderType[];
  storageDetail?: AdderType[];
  keychain?: Keychain;
  utilities?: Utility[];
  additionalDocuments?: FileUpload[];
  parkingFacilities?: boolean;
  furnishingStandard?: RentalObjectFurnishingStandard;

  details?: RentalObjectDetails;

  useDefaultHouseRules?: boolean;
  houseRulesUploads?: FileUpload[];
}

export { RentalObject, RentalObjectFurnishingStandard, RentalObjectFurnishingStandardEnum };
